<div class="row">
  <div class="col">
    <div class="jumbotron" style="padding-top: 0px; padding-bottom: 0px;">
      <h3 class="display-4" style="font-size: 30px">{{'event.details.overviewDevices' | translate}}</h3>
      <p class="lead">
        {{'event.details.overviewDevicesDesc' | translate}}
      </p>
      <hr class="my-4">
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12 col-lg-6">
    <div class="card" style="width: 100%">
      <div class="card-header">
        {{'event.details.requestedSoftware' | translate}}
      </div>
      <div class="card-body">
        <table class="table">
          <thead>
            <tr>
              <th>{{'event.details.licenses' | translate}}</th>
              <th class="text-center ">{{'event.details.quantitySoftware' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{'event.details.softwareWaiter' | translate}}</td>
              <td class="text-center">
                <span class="badge badge-primary badge-pill ">{{requestedWaiterSoftware}}</span>
              </td>
            </tr>
            <tr>
              <td>{{'event.details.softwareCashRegister' | translate}}</td>
              <td class="text-center">
                <span class="badge badge-primary badge-pill">{{requestedCashRegisterSoftware}}</span>
              </td>
            </tr>
            <tr>
              <td>{{'event.details.softwareMainDevice' | translate}}</td>
              <td class="text-center">
                <span class="badge badge-primary badge-pill">{{requestedMainDeviceSoftware}}</span>
              </td>
            </tr>
            <tr>
              <td>{{'event.details.softwarePrinter' | translate}}</td>
              <td class="text-center">
                <span class="badge badge-primary badge-pill">{{requestedPrinterSoftware}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-6">
    <div class="card">
      <div class="card-header">
        {{'event.details.requestedHardware' | translate}}
      </div>
      <div class="card-body">
        <table class="table ">
          <thead>
            <tr>
              <th>{{'event.details.product' | translate}}</th>
              <th class="text-center ">{{'event.details.quantity' | translate}}</th>
              <th class="text-center ">{{'event.details.ownHardware' | translate}}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{'event.details.phonesTablets' | translate}}</td>
              <td class="text-center "><span
                  class="badge badge-primary badge-pill ">{{requestedPhoneHardware}}</span>
              </td>
              <td class="text-center "><span
                  class="badge badge-primary badge-pill">{{(requestedPhoneSoftware-requestedPhoneHardware) >= 0 ? requestedPhoneSoftware-requestedPhoneHardware : 0}}</span>
              </td>
            </tr>
            <tr>
              <td>{{'event.details.printers' | translate}}</td>
              <td class="text-center "><span
                  class="badge badge-primary badge-pill ">{{requestedPrinterHardware}}</span>
              </td>
              <td class="text-center "><span
                  class="badge badge-primary badge-pill">{{(requestedPrinterSoftware-requestedPrinterHardware) >= 0 ? requestedPrinterSoftware-requestedPrinterHardware : 0}}</span>
              </td>
            </tr>
            <tr>
              <td>{{'event.details.fiscalPrinter' | translate}}</td>
              <td class="text-center">
                <span class="badge badge-primary badge-pill">{{requestedFiscalPrinterHardware}}</span>
              </td>
              <td class="text-center">
                <span class="badge badge-primary badge-pill">{{(requestedFiscalPrinterSoftware-requestedFiscalPrinterHardware) >= 0 ? requestedFiscalPrinterSoftware-requestedFiscalPrinterHardware : 0}}</span>
              </td>
            </tr>
            <tr>
              <td>{{'event.details.routers' | translate}}</td>
              <td class="text-center "><span
                  class="badge badge-primary badge-pill ">{{getTotalQuantity(event.requestedRouterTypes)}}</span>
              </td>
              <td></td>
            </tr>
            <tr *ngFor="let requestedCable of getGroupByCables(event.requestedCable) ">
              <td>{{'event.details.cable' | translate}} -
                {{requestedCable.cables.cableType.length}}M</td>
              <td class="text-center "><span class="badge badge-primary badge-pill ">{{requestedCable.quantity}}</span>
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-6">
    <div class="card">
      <div class="card-header">
        {{'event.details.additionalCosts' | translate}}
      </div>
      <div class="card-body">
        <table class="table ">
          <thead>
            <tr>
              <th>{{'event.details.additionalCostName' | translate}}</th>
              <th class="text-center ">{{'event.details.additionalCostQuantity' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let additionalCost of additionalCostsArray">
            @if (additionalCost.quantity > 0) {
              <tr>
                <td>{{additionalCost.title}}</td>
                <td class="text-center">
                  <span class="badge badge-primary badge-pill">{{additionalCost.quantity}}</span>
                </td>
              </tr>
            }
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <div class="col-12 col-lg-6">
    <div class="card">
      <div class="card-header">
        {{'event.details.addProducts' | translate}}
      </div>
      <div class="card-body">
        <table class="table" *ngIf="addProducts.length > 0">
          <thead>
            <tr>
              <th>{{'event.details.productName' | translate}}</th>
              <th>{{'event.details.productQuantity' | translate}}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let product of addProducts">
              <tr>
                <td style="width: 80%">{{product.name}}</td>
                <td style="width: 10%">
                  @if (product.id === 3 || product.id === 11) {
                    <div style="text-align: center;">1</div>
                  } @else {
                    <kendo-numerictextbox
                      [style.width.px]="45"
                      [style.height.px]="32"
                      [min]="0"
                      [max]="99"
                      [autoCorrect]="true"
                      [changeValueOnScroll]="false"
                      [decimals]="0"
                      [format]="'#'"
                      [spinners]="false"
                      [(ngModel)]="product.quantity"
                      (ngModelChange)="onProductQuantityChange()"
                    ></kendo-numerictextbox>
                  }

                </td>
                <td style="width: 10%">
                  <button kendoButton [rounded]="'full'" (click)="removeProduct(product)" style="background-color: #57c6f2; color: white; width: 30px; height: 30px; font-weight: 700; font-size: medium">X</button>
                </td>
              </tr>
            </ng-container>
            <tr>
              <td>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="showQuantityError" style="color: red">{{'event.details.quantityError' | translate}}</div>
        <div class="row" style="margin-left: 0px; margin-right: 0px">
          <kendo-dropdownlist
            style="max-width: 300px; margin-left: 0px"
            [data]="getFilteredProducts()"
            valueField="id"
            textField="name"
            [defaultItem]="defaultItem"
            [(value)]="selectedProduct"
            (valueChange)="onProductSelected($event)">
          </kendo-dropdownlist>
          @if (canAddProducts) {
            <div style="margin-right: 0px; margin-left: auto">
              <button class="btn btn-primary" (click)="updateEvent()">{{'printers.save' | translate}}</button>
            </div>
          }
        </div>
        <ng-template #addModal let-modal>
          <div class="modal-header" style="display: block">
            <div style="font-size: xx-large; justify-self: center">{{'event.details.addProducts' | translate}}</div>
          </div>
          <div class="modal-body" style="text-align: center">
            <div style="font-size: large">{{'event.details.addProductsQuestion' | translate}}</div>
            <div style="font-size: large; font-weight: 700">{{'event.details.addProductsWarning' | translate}}</div>
          </div>
          <div class="modal-footer" style="justify-content: space-around">
            <button class="btn btn-secondary" (click)="modal.dismiss()">{{'offers.request.cancel' | translate}}</button>
            <button class="btn btn-primary" (click)="modal.close('ok click')">{{'printers.confirm' | translate}}</button>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>
